module.exports = __webpack_public_path__ + "static/media/1POLICY45.96ca24c4.jpg";